export default "__VITE_ASSET__1IS7Np0g__"